import { Component, OnInit } from '@angular/core';
import {ConfService} from "../../conf.service";
import {GetPasswordComponent} from '../connectors/connectors.component';
import {AddNewGatewayComponent} from '../api-gateway-settings/api-gateway-settings.component';
import {MatDialog, MatDialogRef} from '@angular/material';

declare let $;
@Component({
  selector: 'app-cloud-platform-settings',
  templateUrl: './cloud-platform-settings.component.html',
  styleUrls: ['./cloud-platform-settings.component.scss']
})
export class CloudPlatformSettingsComponent implements OnInit {

  constructor(private confPost: ConfService, private dialog: MatDialog) { }
  selectedCloudInfra: any;
  data: any;
  flag: any;
  ngOnInit() {
      this.confPost.getSettingsCRUD(localStorage.getItem('partner'), localStorage.getItem('account'))
          .subscribe(data => {
              this.data = data[0];
              if (this.data !== undefined && this.data['partner_settings'] !== undefined) {
                  this.selectedCloudInfra = this.data['partner_settings']['cloud_infrastructure'];
                  this.flag = true;
              } else {
                  this.flag = false;
              }
          });
  }
    deactivate(a) {
        this.data.partner_settings.cloud_infrastructure[a].status = 'deactive';
        this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.data.id, this.data).subscribe(res => {
            alert('Deactivation Succesful');
        }, error => {
            alert('Error while deactivating. Please try again after sometime.');
            this.data.partner_settings.cloud_infrastructure[a].status = 'active';
        });
    }
    activate(a) {
        for (let i = 0; i < this.data.partner_settings.cloud_infrastructure[a].length; i++ ) {
            if (i !== a) {
                this.data.partner_settings.cloud_infrastructure[a]['status'] = 'deactive';
            } else {
                this.data.partner_settings.cloud_infrastructure[a]['status'] = 'active';
            }
        }
        this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.data.id, this.data).subscribe(res => {
            alert('Activation Succesful');
        }, error => {
            alert('Error while activating. Please try again after sometime.');
        });
    }
    deleteCloud(a) {
        this.data.partner_settings.cloud_infrastructure.splice(a,1);
        this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.data.id, this.data).subscribe(res => {
            alert('Deletion Succesful');
        }, error => {
            alert('Error while deleting. Please try again after sometime.');
        });
    }
    openDialog() {
        const dialogRef = this.dialog.open(AddNewCloudComponent, {
            width: '90%'
        });
        dialogRef.afterClosed().subscribe(res => {
            if (res !== undefined && res.length > 0) {
            this.data.partner_settings.cloud_infrastructure.push(res);
            res.status = 'deactive';
            this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.data.id, this.data).subscribe(res => {
                alert('Addition Succesful');
            }, error => {
                alert('Error while adding. Please try again after sometime.');
            }); }
        });
    }
    update(selected) {
      this.data.partner_settings.cloud_infrastructure[0] = selected;
      this.selectedCloudInfra = selected;
      this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.data.id, this.data).subscribe( success =>{
          alert('Updation Successful');
      }, err => {
          alert('Error. Please try again.');
      });
  }

}


@Component({
    selector: 'app-addNewCloud',
    templateUrl: './addNewCloud.component.html',
    styleUrls: ['./addNewCloud.component.scss']
})
export class AddNewCloudComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<AddNewCloudComponent>) { }
    cloudInfraList = [
        {
            cloudProvider: 'AWS',
            image: './assets/img/vault/awssecretsmanager.png',
            region: 'US-East (N.Virginia)',
            description: 'Host your applications in AWS',
            value: 'aws'
        },
        {
            cloudProvider: 'Azure',
            image: './assets/img/partnerOnboarding/azure.png',
            region: 'Central US',
            description: 'Host your applications in Azure',
            value: 'azure'
        },
        {
            cloudProvider: 'GCP',
            image: './assets/img/partnerOnboarding/gcp.png',
            region: 'US-East (N.Virginia)',
            description: 'Host your applications in GCP',
            value: 'gcp'
        },
        {
            cloudProvider: 'On Premise',
            image: './assets/img/partnerOnboarding/onPremises3.jpg',
            region: 'US-East (N.Virginia)',
            description: 'Host your applications on your premises',
            value: 'onpremise'
        }
    ];
    selected: any;
    ngOnInit(): void {
        const time = new Date();
    }
    updateSetting() {
        this.dialogRef.close(this.selected);
    }
    close() {
        this.dialogRef.close();
    }
    selectCloudInfra(index) {
            this.selected = this.cloudInfraList[index];
            for (let i = 0; i < this.cloudInfraList.length; i++) {
                const id = 'selectedCloudInfra' + i;
                if (index === i) {
                    $('#' + id).css('border', '2px solid #ff672d');
                } else {
                    $('#' + id).css('border', 'transparent');
                }
            }
    }
}

